import { render, staticRenderFns } from "./solution1.vue?vue&type=template&id=0c5fe6c7&scoped=true&"
import script from "./solution1.vue?vue&type=script&lang=js&"
export * from "./solution1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5fe6c7",
  null
  
)

export default component.exports